import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding":"16px","height":"100%","display":"flex","flex-direction":"column","justify-content":"space-between","box-sizing":"border-box"}
}
const _hoisted_2 = {
  class: "cm-align-center",
  style: {"flex":"1"}
}
const _hoisted_3 = { class: "cm-align-center gap-x-10" }
const _hoisted_4 = { class: "cm-align-center" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text cm-align-center" }
const _hoisted_7 = { class: "cm-align-center gap-x-10" }
const _hoisted_8 = { class: "cm-align-center" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "text cm-align-center" }
const _hoisted_11 = { class: "cm-align-center" }

import { formLabelStyle } from '@/components/cmForm/globalOpt'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormType } from '@/components/cmForm/types'
import { PermissionFe } from '@/services/service-permission.service'
import { formatMapToOptions } from '@/utils/tool'
import PolicyBindScope from '@/views/dashboard/policy/_components/policy-bind-scope.vue'
import { policyBindScopeFormRules } from '@/views/dashboard/policy/_components/policy-bind-scope-form-rule'
import { PolicySettingType, PolicyType, } from '@/views/dashboard/_enum/policy-type'
import { SaveSettingsReq, } from '@/views/dashboard/policy/policy-common.service'
import { ElMessage } from 'element-plus'
import { computed, nextTick, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { frequencyState, union } from '../types'
import { getFrequencyStateLabelMap } from '../traffic-control-i18n-labels'
import TaskTimeEdit from '@/views/dashboard/_components/task-time/task-time-edit.vue'
import { DefaultEndTaskTime } from '@/views/dashboard/_components/task-time/task-time.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'strategy-setting',
  props: {
  api: {
    type: Object as PropType<{
      saveOrUpdateApi: (data: SaveSettingsReq) => Promise<void>;
      getApi: ({ id, type }: { id: string; type: PolicySettingType }) => Promise<void>;
    }>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  hasPermission: {
    type: Boolean,
    default: false,
  },
  fromGroupId: {
    type: Number,
  },
},
  emits: ['update:modelValue', 'refresh'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const frequencyStateLabelI18n = computed(() => getFrequencyStateLabelMap(t))

const props = __props

// 表单的禁用/启用
const disabled = ref(!props.hasPermission)
// 表单实例对象
const formRef = ref()
// 表单的提交loading
const loading = ref(false)
const loadingPage = ref(false)
const strategyOver = ref({ type: PolicyType.terminal_flow_monitor, current: '' })
// 默认表单
const defaultFormData = {
  name: '', group_ids: [], bind_mode: 0, device_ids: [] as string[], down_speed: 100, up_unit: 0, down_unit: 0, up_speed: 100, frequency: frequencyState.day, regular_tasks: [...DefaultEndTaskTime]
}
// 表单数据
const form: any = ref(defaultFormData)
// 表单项配置
const formColumns = computed(() => {
  void locale.value
  return {
    name: { label: t('terminalTrafficStateList.policyName'), required: true, inputOpt: { maxlength: 50 }, },
    up_speed: { colOpt: { span: 24 },label: t('terminalTrafficStateList.maxUpSpeed'), slot: true, required: true },
    down_speed: {colOpt: { span: 24 }, label: t('terminalTrafficStateList.maxDownSpeed'), slot: true, required: true },
    frequency: {
      label: t('terminalTrafficStateList.executeFreq'), required: false, type: FormType.Radio, dictData: formatMapToOptions(frequencyStateLabelI18n.value, true), events: {
        change() {
          form.value.regular_tasks = [...DefaultEndTaskTime]
        }
      }
    }, regular_tasks: { label: t('terminalTrafficStateList.regularTasks'), required: false, slot: true },
    group_ids: {
      required: false,
      label: t('policyBindScope.applyMode'),
      prop: 'group_ids',
      formItemOpt: { required: false },
      rules: policyBindScopeFormRules(() => form.value, t),
      labelSlot: true,
      slot: true,
      colOpt: { span: 24 },
    },
  }
})
const emits = __emit
const visible = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  },
})
const cancel = () => {
  visible.value = false
  handleReset();
}
const validateTree = () => {
  formRef.value?.ruleFormRef?.validateField?.('group_ids')
}

// 表单重置
const handleReset = async () => {
  form.value = { ...defaultFormData }
}
// 表单数据提交
const handleSubmit = async () => {
  const valid = await formRef.value.handleSubmit()
  if (!valid) return
  const bm = form.value.bind_mode ?? 0
  loadingPage.value = true
  loading.value = disabled.value = true
  const formCopy = { ...form.value }
  delete formCopy.name
  delete formCopy.id
  delete formCopy.group_ids
  const strategy = { ...formCopy }
  const formData: SaveSettingsReq = {
    name: form.value.name,
    group_ids: form.value.group_ids,
    device_ids: form.value.device_ids || [],
    bind_mode: bm,
    id: form.value.id,
    type: PolicySettingType.terminal_flow_monitor,
    strategy_type: PolicyType.terminal_flow_monitor,
    strategy: JSON.stringify(strategy),
  }
  console.log('formData :>> ', formData);
  const result: any = await props.api.saveOrUpdateApi(formData).finally(() => loading.value = loadingPage.value = disabled.value = false)
  const ok = result?.resp_common?.msg === 'ok'
  ElMessage({
    type: ok ? 'success' : 'error',
    message: ok ? t('terminalTrafficStateList.operateSuccess') : t('terminalTrafficStateList.operateFailed'),
  })
  if (ok) {
    emits('refresh')
    visible.value = false
    form.value.id = undefined
  }
}
watch(
  () => props.modelValue,
  async (nv, ov) => {
    handleReset()
    if (nv && props.id) {
      loadingPage.value = true
      strategyOver.value.current = props.id
      const result: any = await props.api.getApi({
        id: props.id,
        type: PolicySettingType.terminal_flow_monitor,
      })
      form.value = {
        ...result,
        ...result.strategy,
        group_ids: result.strategy_group_ids,
        bind_mode: result.bind_mode ?? 0,
        device_ids: result.device_ids ?? [],
        id: props.id,
      }
      loadingPage.value = false
      console.log('form.value :>> ', form.value);
    }
  },
  {
    immediate: true,
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (visible.value)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CmForm, {
          formSize: _unref(FormSize).Small,
          ref_key: "formRef",
          ref: formRef,
          style: {"flex":"1","overflow-y":"auto","overflow-x":"hidden"},
          modelValue: form.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form).value = $event)),
          formType: _unref(FormActionType).Other,
          "onUpdate:formType": _cache[10] || (_cache[10] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
          disabled: disabled.value,
          "onUpdate:disabled": _cache[11] || (_cache[11] = ($event: any) => ((disabled).value = $event)),
          formColumns: formColumns.value,
          formOpt: { 'label-width': 'auto', labelPosition: 'left' },
          opeRowOpt: { justify: 'start', style: { marginTop: '20px' } },
          onReset: _cache[12] || (_cache[12] = () => (visible.value = false)),
          rowOpt: { style: { display: 'grid' }, class: 'gap-20' }
        }, {
          group_ids: _withCtx(() => [
            _createVNode(PolicyBindScope, {
              "bind-mode": form.value.bind_mode ?? 0,
              "group-ids": form.value.group_ids || [],
              "device-ids": form.value.device_ids || [],
              "preset-group-id": form.value.id ? undefined : __props.fromGroupId,
              "permission-key": _unref(PermissionFe).flow_monitor,
              "strategy-over": strategyOver.value,
              disabled: disabled.value,
              "onUpdate:bindMode": _cache[0] || (_cache[0] = 
            (v) => {
              form.value.bind_mode = v
              nextTick(() => validateTree())
            }
          ),
              "onUpdate:groupIds": _cache[1] || (_cache[1] = ($event: any) => (form.value.group_ids = $event)),
              "onUpdate:deviceIds": _cache[2] || (_cache[2] = 
            (v) => {
              form.value.device_ids = v
              nextTick(() => validateTree())
            }
          ),
              onGroupUpdate: validateTree
            }, null, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
          ]),
          "group_ids-label": _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                style: _normalizeStyle(_unref(formLabelStyle))
              }, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 5)
            ])
          ]),
          up_speed: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input_number, {
                class: "flow-input-size",
                "controls-position": "right",
                size: "small",
                step: {0:100,1:1}[form.value.up_unit],
                min: {0:100,1:1}[form.value.up_unit],
                max: 9999,
                modelValue: form.value.up_speed,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.up_speed) = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["step", "min", "modelValue"]),
              _createVNode(_component_el_select, {
                size: "small",
                style: {"width":"100px"},
                modelValue: form.value.up_unit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.up_unit) = $event)),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (form.value.up_speed = form.value.up_unit === _unref(union).KB ? 100:form.value.up_speed))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "KB",
                    value: _unref(union).KB
                  }, null, 8, ["value"]),
                  _createVNode(_component_el_option, {
                    label: "MB",
                    value: _unref(union).MB
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('terminalTrafficStateList.perSecond')), 1),
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/manage/terminal-traffic-control/traffic-control/images/blue_tips",
                    width: "20",
                    height: "20",
                    class: "cm-ui-mr5 cm-ui-ml5",
                    monochrome: "",
                    "aria-hidden": false,
                    "aria-label": "tip"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.$t('terminalTrafficStateList.minSpeedTip')), 1)
                ])
              ])
            ])
          ]),
          down_speed: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_input_number, {
                class: "flow-input-size",
                "controls-position": "right",
                size: "small",
                min: {0:100,1:1}[form.value.down_unit],
                step: {0:100,1:1}[form.value.down_unit],
                max: 9999,
                modelValue: form.value.down_speed,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.down_speed) = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["min", "step", "modelValue"]),
              _createVNode(_component_el_select, {
                size: "small",
                style: {"width":"100px"},
                modelValue: form.value.down_unit,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.down_unit) = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (form.value.down_speed = form.value.down_unit === _unref(union).KB ? 100:form.value.down_speed))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "KB",
                    value: _unref(union).KB
                  }, null, 8, ["value"]),
                  _createVNode(_component_el_option, {
                    label: "MB",
                    value: _unref(union).MB
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('terminalTrafficStateList.perSecond')), 1),
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/manage/terminal-traffic-control/traffic-control/images/blue_tips",
                    width: "20",
                    height: "20",
                    class: "cm-ui-mr5 cm-ui-ml5",
                    monochrome: "",
                    "aria-hidden": false,
                    "aria-label": "tip"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.$t('terminalTrafficStateList.minSpeedTip')), 1)
                ])
              ])
            ])
          ]),
          regular_tasks: _withCtx(({ prop }) => [
            _createVNode(TaskTimeEdit, {
              modelValue: form.value[prop],
              "onUpdate:modelValue": ($event: any) => ((form.value[prop]) = $event),
              "main-switch": true,
              "mix-type": form.value.frequency,
              "default-end-min": 23 * 60 + 50
            }, null, 8, ["modelValue", "onUpdate:modelValue", "mix-type"])
          ]),
          _: 1
        }, 8, ["formSize", "modelValue", "formType", "disabled", "formColumns"]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: cancel,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (handleSubmit())),
            loading: loading.value,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])), [
        [_directive_loading, loadingPage.value]
      ])
    : _createCommentVNode("", true)
}
}

})